import React from 'react';

import Prism from 'prismjs';
import 'prismjs/components/prism-python';

import {Card, Stack, Textarea} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import Divider from "@mui/joy/Divider";
import IconButton from "@mui/joy/IconButton";
import Button from "@mui/joy/Button";

// components
import MessageAttachment from "./MessageAttachment";
import MessageSticker from "./MessageSticker";
import BaseApi from "../../utils/BaseApi";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import MessageLink from "./MessageLink";

// icons
import EditIcon from '@mui/icons-material/Edit';
import TelegramIcon from "@mui/icons-material/Telegram";
import CloseIcon from "@mui/icons-material/Close";


import 'prismjs/themes/prism-okaidia.css';


function prepareContent(content, parser) {
    content = content ? parser.makeHtml(content) : '<div></div>'
    return content.replaceAll(
        /(@([A-Za-z]+(\.?)[A-Za-z0-9]+))/g,
        (match) => {
            return `<span class="commentDogBubble">${match}</span>`
        }
    )
}


class MessageContent extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            replyTo: null,
            message: this.props.message,
            edit: false,
        }
        this.editRef = React.createRef()
    }

    async componentDidMount() {
        if (this.props.message.reply_to && this.props.showReply){
            let message = await this.retrieveMessage(this.props.message.reply_to)
            this.setState({
                replyTo: message,
            })
        }
        Prism.highlightAll();
    }

    componentDidUpdate(prevProps, prevState) {
        Prism.highlightAll();
    }

    async retrieveMessage(id){
        const url = `message/${id}`;
        const api = new BaseApi();
        let params = {};
        let response = await api.get(
            url,
            params
        );
        return response.data
    }

    async patchMessage(){
        const url = `message/${this.props.message.id}/`;
        const api = new BaseApi();
        let content = this.editRef.current?.value;
        if (content){
            let response = await api.patch(
                url,
                {
                    content: content,
                    edited: true,
                }
            )
            let message = this.state.message;
            message.content = response.data.content;
            message.edited = true;
            this.setState({
                message: message,
                edit: false,
            })
        }
    }

    render() {
        switch (this.state.message.xtype){
            case 'COMMON':
            case 'AGENT':
            case 'SYSTEM':
                return(
                    <Stack
                        sx={{
                            maxHeight: this.props.trim?'80px':null,
                            overflow: this.props.trim?'hidden':null,
                        }}
                        spacing={0.5}
                    >
                        <Stack
                            direction={'row'}
                            spacing={1}
                        >
                            <Typography
                                level={'body-sm'}
                                color={this.props.isMyMessage ? 'primary' : this.props.isRead ? 'null' : 'white'}
                            >
                                <strong>{this.state.message.owner?.user?.first_name} {this.state.message.owner?.user?.last_name}</strong>
                            </Typography>
                            {
                                this.props.allowEdit && this.state.message.owner?.id === this.context.subscriberObject.id && !this.state.edit?
                                    <IconButton
                                        size={'sm'}
                                        onClick={() => {
                                            this.setState({
                                                edit: true
                                            })
                                        }}
                                        sx={{
                                            mt: 0,
                                            mb: 0,
                                            mr: 0,
                                            minHeight: '16px',
                                            minWidth: '16px',
                                        }}
                                        color={'neutral'}
                                        variant={'plain'}
                                    >
                                        <EditIcon
                                            sx={{
                                                fontSize: '16px',
                                            }}
                                        />
                                    </IconButton>:
                                    null
                            }
                            {
                                this.state.edit?
                                    <IconButton
                                        size={'sm'}
                                        onClick={() => {
                                            this.setState({
                                                edit: false
                                            })
                                        }}
                                        sx={{
                                            mt: 0,
                                            mb: 0,
                                            mr: 0,
                                            minHeight: '16px',
                                            minWidth: '16px',
                                        }}
                                        color={'neutral'}
                                        variant={'plain'}
                                    >
                                        <CloseIcon
                                            sx={{
                                                fontSize: '16px',
                                            }}
                                        />
                                    </IconButton>:
                                    null
                            }
                        </Stack>
                        {
                            this.state.replyTo ?
                                <Card
                                    variant={this.props.isMyMessage?'soft':'plain'}
                                    size={'sm'}
                                    color={'neutral'}
                                    sx={{
                                        width: '100%',
                                        cursor: 'pointer'
                                    }}
                                    orientation="horizontal"
                                    onClick={() => {
                                        let message = document.getElementById('MessageCard' + this.state.replyTo.id);
                                        let area = document.getElementById('MessengerScrollableArea')
                                        let commentCard = document.getElementById('MessageCard' + this.state.replyTo.id);
                                        area.scroll(0, message.offsetTop - 100);
                                        commentCard.style.backgroundColor = 'purple';
                                        commentCard.style.color = 'white';
                                        setTimeout(()=>{
                                            commentCard.style.backgroundColor = null;
                                            commentCard.style.color = null;
                                        }, 1000);
                                    }}
                                >
                                    <Divider
                                        color={'primary'}
                                        sx={{
                                            px: 0.2,
                                            writingMode: 'vertical-rl',
                                        }}
                                    >
                                        В ответ
                                    </Divider>
                                    <MessageContent
                                        message={this.state.replyTo}
                                        isMyMessage={false}
                                        isRead={true}
                                        parser={this.props.parser}
                                        trim={true}
                                    />
                                </Card>
                                : null
                        }
                        {
                            this.state.edit?
                                <Textarea
                                    slotProps={{
                                        textarea: {
                                            ref: this.editRef
                                        }
                                    }}
                                    defaultValue={this.state.message.content}
                                    minRows={5}
                                    endDecorator={
                                        <Button
                                            size={'sm'}
                                            color="primary"
                                            onClick={this.patchMessage.bind(this)}
                                            endDecorator={<TelegramIcon />}
                                        >
                                            Сохранить
                                        </Button>
                                    }
                                />:
                                <div>
                                    {
                                        this.state.message?.thinking ?
                                            <details>
                                                <summary>Размышления</summary>
                                                <div className="content">'
                                                    {this.state.message.thinking}
                                                </div>
                                            </details> :
                                            null
                                    }
                                    <div
                                        style={{
                                            wordWrap: 'break-word', /* Modern approach */
                                            wordBreak: 'break-word', /* Alternative */
                                            overflowWrap: 'break-word', /* Latest standard */
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                prepareContent(this.state.message?.content, this.props.parser)
                                        }}
                                    />
                                </div>
                        }
                        {
                            this.state.message.edited?
                                <Typography
                                    level={'body-sm'}
                                    sx={{
                                        textAlign: 'right'
                                    }}
                                >
                                    <i>Сообщение было отредактировано</i>
                                </Typography>:
                                null
                        }
                    </Stack>
                )
            case 'UPLOAD':
                return (
                    <Stack
                        sx={{
                            maxHeight: this.props.trim?'80px':null,
                            overflow: this.props.trim?'hidden':null,
                        }}
                        spacing={0.5}
                    >
                        <Typography
                            level={'body-sm'}
                            color={this.props.isMyMessage ? 'primary' : this.props.isRead ? 'null' : 'white'}
                        >
                            <strong>{this.state.message.owner?.user?.first_name} {this.state.message.owner?.user?.last_name}</strong>
                        </Typography>
                        <MessageAttachment
                            hideModal={this.props.trim}
                            message={this.state.message}
                        />
                    </Stack>
                )
            case 'STICKER':
                return (
                    <Stack
                        sx={{
                            maxHeight: this.props.trim?'80px':null,
                            overflow: this.props.trim?'hidden':null,
                        }}
                        spacing={0.5}
                    >
                        <Typography
                            level={'body-sm'}
                            color={this.props.isMyMessage ? 'primary' : this.props.isRead ? 'null' : 'white'}
                        >
                            <strong>{this.state.message.owner?.user?.first_name} {this.state.message.owner?.user?.last_name}</strong>
                        </Typography>
                        <MessageSticker
                            message={this.state.message}
                        />
                    </Stack>
                )
            case 'LINK':
                return (
                    <MessageLink
                        message={this.state.message}
                    />
                )
            default:
                return <></>
        }

    }
}

export default MessageContent
